import type { CookieConsentConfig } from 'vanilla-cookieconsent';

export const cookieConsentConfig: CookieConsentConfig = {
    mode: 'opt-in',

    guiOptions: {
        consentModal: {
            layout: 'box',
            position: 'bottom left',
            equalWeightButtons: true,
            flipButtons: false,
        },
        preferencesModal: {
            layout: 'box',
            equalWeightButtons: true,
            flipButtons: false,
        },
    },

    categories: {
        necessary: {
            enabled: true,
            readOnly: true,
        },

        functional: {
            enabled: false,
        },

        analytics: {
            enabled: false,
        },

        marketing: {
            enabled: false,
        },

        other: {
            enabled: false,
        },
    },

    cookie: {
        name: 'cc_cookie',
        path: '/',
        sameSite: 'Lax',
        secure: true,
        expiresAfterDays: 182,
    },

    language: {
        default: 'ru',

        translations: {
            ru: {
                consentModal: {
                    title: 'Мы ценим вашу конфиденциальность.',
                    description:
                        'Мы используем cookie-файлы для доступа к ресурсам и функциональным возможностям Личного кабинета.',
                    acceptAllBtn: 'Принять все',
                    acceptNecessaryBtn: 'Только обязательные',
                    showPreferencesBtn: 'Настройки',
                },

                preferencesModal: {
                    title: 'Настройки конфиденциальности',
                    acceptAllBtn: 'Принять все',
                    acceptNecessaryBtn: 'Только обязательные',
                    savePreferencesBtn: 'Сохранить',
                    closeIconLabel: 'Закрыть',

                    sections: [
                        {
                            description:
                                'С помощью этого инструмента вы можете выбрать категории cookie-файлов, используемые на сайте.',
                        },

                        {
                            title: 'Обязательные',
                            description:
                                'Эти файлы cookie необходимы для основных функций нашего сайта.',
                            linkedCategory: 'necessary',
                        },

                        {
                            title: 'Функциональные',
                            description:
                                'Эти файлы cookie используются для дополнительных функциональных возможностей Личного кабинета.',
                            linkedCategory: 'functional',
                        },

                        {
                            title: 'Аналитические',
                            description:
                                'Эти файлы cookie позволяют анализировать использование сайта, измерять его производительность и улучшать работу интерфейса.',
                            linkedCategory: 'analytics',
                        },

                        {
                            title: 'Маркетинговые',
                            description:
                                'Эти файлы cookie используются для маркетинговых и рекламных функций.',
                            linkedCategory: 'marketing',
                        },

                        {
                            title: 'Другие',
                            description:
                                'Другие инструменты обработки данных, не относящиеся к перечисленным категориям.',
                            linkedCategory: 'other',
                        },
                    ],
                },
            },
        },
    },
};
